import React from "react";
import { useLocation } from "react-router-dom";
import useResponsive from "src/utils/useResponsive";
import { isZaraHeader } from "./utils/Navigation.utils";
import PreownedHeader from "./PreownedHeader/PreownedHeader";
import { Button } from "@zarafront/lib-zds";
import { useNavigationLogic } from "./utils/useNavigationLogic";
import ZaraHeader from "./ZaraHeader/ZaraHeader";
import { ROUTE_PATHS } from "src/utils/constants";
import { t } from "i18next";

const MainHeader = ({ children }) => {
  const { WS, WSM } = useResponsive();
  const { pathname } = useLocation();

  const {whiteBackGround, showBackIcon, handleBackClick, handleDimissClick, onLogoClickHandled} = useNavigationLogic();

  const wrapperProps = {
    whiteBackGround, showBackIcon, handleBackClick, handleDimissClick, onLogoClickHandled
  }

  const showZaraHeader = isZaraHeader(pathname);

  const getHeaderComponent = () => {
    if (!showZaraHeader && (WS || pathname.includes(ROUTE_PATHS.PRODUCTS))) {
      return <PreownedHeader wrapperProps={wrapperProps} />;
    } else if (showZaraHeader && WSM) {
      return <ZaraHeader wrapperProps={wrapperProps} />;
    } else {
      return null;
    }
  };

  const scrollToMainContent = () => {
    const el = document.getElementById("main-content");
    if (el) {
      el.focus({ preventScroll: true });
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <Button variant="primary" className="skip-link" onClick={scrollToMainContent}>
        {t("skip_to_main_content")}
      </Button>
      {getHeaderComponent()}
      {children}
    </>
  );
}

export default MainHeader;
